import { useState } from "react";
import { Button, Form, Input, Modal, Popconfirm } from "antd";
import {
  SendOutlined,
  CloseCircleOutlined
} from '@ant-design/icons';

import api from '../../services/nysService';
import { recordError } from "../../utils/logService";
import { 
  Messages, 
  Notify, 
  openNotification, 
  util
} from '@seims/shared';

const SendHostEmail = (props) => {

  const [disabled, setDisabled] = useState(true);
  const [pageTitle, setPageTitle] = useState("Enter Host Email");
  const [modalStatus, setModalStatus] = useState("");

  const formName = "SendHostEmailForm";
  const [form] = Form.useForm();

  const onSubmit = async (host) => {
    var msg;
    var action = "Host Institution";

    const tempMsg = "Submitting in progress, please wait...";
    openNotification("Verifying Email Address", tempMsg, Notify.INFO);

    try {
      const response = await api.sendHost(props.userId, host.email, props.intake);

      //!TEMPORARY STATUS 204 
      if (response.status == 204) {
        clearFormContents();
        msg = util.parseMessage(Messages.EMAIL_SEND_SUCCESS, action);
        openNotification(action, msg, Notify.SUCCESS);

        return;
      }

      if (response.status == 200 || response.status == 201) {

        // clearFormContents();
        form.resetFields();
        msg = util.parseMessage(Messages.EMAIL_SEND_SUCCESS, action);
        openNotification(action, msg, Notify.SUCCESS);

        const { data } = response;
        setModalStatus(data.value);
        // props.setCurrentStatus(data.value);

        return;
      }

      msg = util.parseMessage(Messages.EMAIL_SEND_FAILURE, action);
      openNotification(action, msg, Notify.ERROR);

    } catch (error) {
      //? WHEN EMAIL WAS ALREADY SENT TO THIS SPECIFIC ORG
      if (error.response.status == 409) {
        msg = util.parseMessage(Messages.EXIST_ADD_FAILURE, action);
        openNotification(action, msg, Notify.ERROR);
        recordError(error);
        return;
      }

      msg = util.parseMessage(Messages.EMAIL_SEND_FAILURE, action);

      recordError(error);
      openNotification(action, msg, Notify.ERROR);
    }
    //?Adding candidate, status, datetime
  };

  const clearFormContents = () => {
    form.resetFields();
    props.onShow(false);
    setDisabled(true);
  }

  const Confirm = () => {
    form.resetFields();
    props.onShow(false);
    setDisabled(true);
    props.setCurrentStatus(modalStatus);
  };

  const handleCancel = () => {

    if (form.getFieldValue("email")) {
      setDisabled(false);
    } else {
      form.resetFields();
      props.onShow(false);
      setDisabled(false);
      props.setCurrentStatus(modalStatus);
    }
  };

  return (
    <Modal
      title={pageTitle}
      open={props.show}
      closable={false}
      keyboard={false}
      maskClosable={false}
      footer={[
        <div className="modal-footer-buttons">
          <Button
            type="primary"
            htmlType="submit"
            // onSubmit={createUser}
            form={formName}
            key="send"
          >
            <SendOutlined />
            Send
          </Button>

          <Popconfirm
            title="Are you sure you want to close...you will lose all info entered?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => Confirm()}
            onCancel={handleCancel}
            disabled={disabled}
            key="popconfirm"

          >
            <Button onMouseUp={() => handleCancel()} style={{ marginLeft: 10 }} type="danger">
              <CloseCircleOutlined />
              Close
            </Button>
          </Popconfirm>
        </div>
      ]}
    >
      <>
        <div style={{ width: "100%", paddingBottom: 20 }}>
          <h3>Please enter the email you want to send this profile information to.</h3>
        </div>
        <Form
          name={formName}
          form={form}
          layout="horizontal"
          onFinish={onSubmit}
        >
          <Form.Item
            name="email"
            label="Email"
            rules={[
              {
                required: true,
                type: "email",
                message: "Please enter host Email address",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </>
    </Modal>
  );
};

export default SendHostEmail;
